import React from "react";
import  PDFPreview from "./previewTypes/PDFPreview";
import CSVPreview from "./previewTypes/CSVPreview";
import CodePreview from "./previewTypes/CodePreview";
import DownloadPreview from "./previewTypes/DownloadPreview";
import LoadingPreview from "./previewTypes/LoadingPreview";
import ErrorPreview from "./previewTypes/ErrorPreview";
// import HTMLPreview from "./previewTypes/HTMLPreview.tsx";
import WordPreview from "./previewTypes/WordPreview";
import { Preview } from "redux/actions";
import { EThemeType } from "redux/reducers";
import TxtPreview from "./previewTypes/TxtPreview";
import BrowserPreview from "./previewTypes/BrowserPreview";

interface PreviewContentProps {
  loading: boolean;
  error: string | null;
  preview: Preview;
  fileUrl: string;
  theme: EThemeType | undefined;
  fileName?: string;
}

const PreviewContent: React.FC<PreviewContentProps> = ({ 
  loading, 
  error, 
  preview, 
  fileUrl, 
  theme ,
  fileName
}) => {
  if (loading) {
    return <LoadingPreview />;
  }

  if (error) {
    return <ErrorPreview error={error} fileUrl={fileUrl} />;
  }

  if (!preview || !preview.type) return null;

   // Check if this is a Word document with a blob URL
   const isWordWithBlobUrl = preview.type === "word" && 
   preview.url && 
   preview.url.startsWith("blob:");

 // For Word documents, choose between WordPreview and DownloadPreview based on URL type
 if (preview.type === "word") {
   if (isWordWithBlobUrl) {
     // Use DownloadPreview for blob URLs (local files)
     return <DownloadPreview fileType={preview.type} url={preview.url} theme={theme} />;
   } else {
     // Use WordPreview for non-blob URLs (like S3 links)
     return <WordPreview fileUrl={preview.url} />;
   }
 }


  switch (preview.type) {
    case "pdf":
      return <PDFPreview url={preview.url} />;
    case "csv":
      return <CSVPreview rows={preview.rows} fileName={fileName}/>;
    case "json":
      return <CodePreview content={preview.content} language="json" />;
    case "xml":
      return <CodePreview content={preview.content} language="xml" />;
    case "markdown":
      return <TxtPreview content={preview.content} language="markdown" fileName={fileName}  />;
    case "html":
      return <CodePreview content={preview.content} language="htm"/>;
    case "text":
      return <TxtPreview content={preview.content} language="text" fileName={fileName} />;
    case "eml":
        return <TxtPreview content={preview.content} language="eml" fileName={fileName} />;
    case "msg":
        return <TxtPreview content={preview.content} language="msg" fileName={fileName} />;
      case "browser-preview":
      return <BrowserPreview fileType={preview.fileType} url={preview.url} theme={theme} />;
    case "download":
      return <DownloadPreview fileType={preview.fileType} url={preview.url} theme={theme} />;
    default:
      return null;
  }
};

export default PreviewContent;